<template>
  <div class="activity-sale">
    <Navbar title="销售记录"></Navbar>
    <!-- 活动标题 -->
    <div class="activity-title">
      <span v-if="detail.master" class="activity-icon">主</span>
      <span v-if="!detail.master" class="activity-icon copy">副</span>
      <span class="name">{{ detail.name }}</span>
      <div class="label">
        <div class="label1">已发布</div>
        <div v-if="detail.enableReward" class="label2">分销开启</div>
        <div v-if="!detail.enableReward" class="label2">分销关闭</div>
      </div>
    </div>
    <!-- 销售情况 -->
    <div class="sale-info">
      <div class="tltle">该活动共销售{{ saleList.length }}个</div>
      <div class="user" v-for="(item, index) in saleList" :key="index">
        <div class="photo">
          <img src="@/assets/user.png" alt="" />
        </div>
        <div class="detail">
          <div class="phone">
            <a :href="'tel:' + item.phone">{{ item.phone }}</a> 点击联系车主
          </div>
          <div class="referrer" v-if="item.recommendUserPhone">
            (推荐人{{ item.recommendUserPhone }})
          </div>
          <div class="time">购买时间：{{ item.payTime }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Navbar from "@/components/Navbar.vue";
import { activityDetail } from "@/api/activity";
import { orderList } from "@/api/order";

export default {
  components: {
    Navbar
  },
  data() {
    return {
      listQuery: {
        page: 1,
        size: 1000,
        phone: "",
        status: "",
        promotionId: ""
      },
      saleList: [],
      detail: {}
    };
  },
  mounted() {
    this.listQuery.promotionId = this.$route.query.id;
    this.getOrderList();
    this.getDetail(this.$route.query.id);
  },
  methods: {
    // 活动详情
    getDetail(id) {
      activityDetail(id).then(res => {
        // console.log("活动详情 :>> ", res);
        this.detail = res;
      });
    },
    // 销售记录
    getOrderList() {
      orderList(this.listQuery).then(res => {
        // console.log("销售记录 :>> ", res);
        this.saleList = res;
      });
    }
  }
};
</script>
<style lang="scss" scoped>
img {
  height: 100%;
  width: 100%;
}

.activity-sale {
  margin: 10px 20px;
  text-align: left;

  .activity-title {
    margin-bottom: 20px;
    border-bottom: 1px solid #000;

    .activity-icon {
      display: inline-block;
      height: 20px;
      width: 20px;
      margin-right: 5px;
      background-color: #007aff;
      border-radius: 50%;
      text-align: center;
      line-height: 20px;
      color: #fff;
    }

    .copy {
      background-color: #f08300;
    }

    .name {
      display: inline-block;
      margin-bottom: 20px;
      text-align: left;
    }

    .label {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;

      div {
        padding: 5px 10px;
        border: 1px solid #f08300;
        color: #f08300;
        border-radius: 5px;
      }

      .label1 {
        margin-right: 10px;
      }
    }
  }

  .sale-info {
    .tltle {
      margin-bottom: 20px;
    }

    .user {
      display: flex;
      margin-bottom: 20px;

      .photo {
        height: 50px;
        width: 50px;
        margin-right: 10px;
      }

      .detail {
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .time {
          color: #7b7b7b;
          font-size: 14px;
        }

        .referrer {
          font-size: 15px;
        }
      }
    }
  }
}
</style>
